<template>
  <router-link class="breadcrumb" :to="location">
    {{ text }}
    <i class="fa fa-chevron-right fa-xs mr-2"></i>
  </router-link>
</template>
<script>
export default {
  name: 'breadcrumb',
  props: {
    location: String,
    text: String,
  },
};
</script>
<style lang="scss" scoped>
.breadcrumb {
  color: #154194;
  font-size: inherit;
}

.breadcrumb:hover {
  color: #00AED1;
}

.fa-xs {
  font-size: 0.75em;
}
</style>

